/**
 * CityMap - 2D board layout showing districts
 */
import React from 'react';
import { motion } from 'framer-motion';

const CityMap = ({ activeDistrict, level }) => {
  const level1Districts = [
    { id: 'income', name: 'Income', icon: '💰', x: 20, y: 30 },
    { id: 'stability', name: 'Stability', icon: '🏛️', x: 50, y: 30 },
    { id: 'regulation', name: 'Regulation', icon: '⚖️', x: 80, y: 30 }
  ];

  const allDistricts = [
    { id: 'income', name: 'Income', icon: '💰', x: 15, y: 20 },
    { id: 'risk', name: 'Risk', icon: '⚡', x: 40, y: 20 },
    { id: 'knowledge', name: 'Knowledge', icon: '📚', x: 65, y: 20 },
    { id: 'stability', name: 'Stability', icon: '🏛️', x: 25, y: 50 },
    { id: 'growth', name: 'Growth', icon: '📈', x: 50, y: 50 },
    { id: 'regulation', name: 'Regulation', icon: '⚖️', x: 75, y: 50 }
  ];

  const districts = level === 'level_1' ? level1Districts : allDistricts;

  return (
    <div className="w-full h-full relative">
      {districts.map((district) => {
        const isActive = district.id === activeDistrict;
        return (
          <motion.div
            key={district.id}
            className="absolute"
            style={{
              left: `${district.x}%`,
              top: `${district.y}%`,
              transform: 'translate(-50%, -50%)'
            }}
            animate={{
              scale: isActive ? 1.08 : 1,
              opacity: isActive ? 1 : 0.45
            }}
            transition={{ duration: 0.3 }}
          >
            <div
              className={`text-center p-3 rounded-md border ${
                isActive
                  ? 'bg-pine-tint border-pine'
                  : 'bg-bone-raised border-hairline'
              }`}
            >
              <div className="text-2xl mb-1" aria-hidden="true">
                {district.icon}
              </div>
              <div className="text-label text-primary font-medium">{district.name}</div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default CityMap;
